<script setup lang="ts">
import VJsonEditor from "@verbleif/lib/src/components/JsonEditor/VJsonEditor.vue";

/** Read-only JSON in text mode. The editor is only loaded when a tab shows JSON. */
const { value, minHeight = undefined } = defineProps<{
  value: unknown
  minHeight?: number
}>();

// A type-only import keeps the editor out of the main bundle; the enum value is the plain string "text".
</script>

<template>
  <div class="debug-json" :style="minHeight ? { minHeight: `${minHeight}px` } : undefined" data-testid="debug-json">
    <VJsonEditor
      :model-value="value"
      read-only
      :toolbar="false"
    />
  </div>
</template>
